import React from 'react'
import { BaseView, BaseText } from '@/components/base'
import { Switch } from '@/assets/icons'
import { useSendStore } from '@/store/useSendStore'
import { currencyUtils } from '@/utils'

const { formatDynamicCurrency } = currencyUtils

export const SendConversionRate: React.FC = () => {
  const isFiatMode = useSendStore((state) => state.isFiatMode)
  const setIsFiatMode = useSendStore((state) => state.setIsFiatMode)
  const fiatAmount = useSendStore((state) => state.fiatAmount)
  const cryptoAmount = useSendStore((state) => state.cryptoAmount)

  const adaptedAmount = isFiatMode ? cryptoAmount : fiatAmount

  const formattedRelativeAmount = formatDynamicCurrency({
    amount: adaptedAmount.amount,
    currencyCode: adaptedAmount.code,
    showDecimals: true,
  })

  const handleToggleCurrencyMode = () => {
    setIsFiatMode(!isFiatMode)
  }

  return (
    <BaseView row align="center" gap={4}>
      <BaseText
        fontSize={18}
        fontFamily="bold"
        color="white"
        style={{
          textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        }}
      >
        {formattedRelativeAmount || '0'}
      </BaseText>
      <BaseView
        center
        className="cursor-pointer hover:opacity-80 transition-opacity duration-200 active:scale-95"
        style={{
          padding: 8,
          borderRadius: 20,
        }}
        onClick={handleToggleCurrencyMode}
      >
        <Switch
          size={18}
          color="white"
          style={{
            filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1))',
          }}
        />
      </BaseView>
    </BaseView>
  )
}
